<template>
    <div class="popup popup--warning" id="warning">
        <div class="popup__close popup__close--back"></div>
        <div class="popup__block">
            <div class="popup__title">{{ title }}</div>
            <div class="popup-warning">
                <div class="popup-warning__text">{{ text }}</div>
                <div class="popup-warning__buttons">
                    <div class="btn--white" @click="cancel">Отменить</div>
                    <div class="btn custom-close" @click="accept">Подтвердить</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : "WarningPopup",
    props: {
        title: String,
        text : String,
        link : String
    },
    methods: {
        cancel() {
            this.result = 'cancel';
            window.popup.close('#warning');
        },
        accept() {
            this.result          = 'ok';
            window.location.href = this.link;
        }
    },
}
</script>

<style scoped>

</style>